module.exports = __webpack_public_path__ + "img/login-title.70ee2ebb.png";